// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Asset Imports

export default function MarketplaceListingRow() {
   const state = useQuoteContext()
   const permissions = state.featurePermissions['MarketplaceListing']

   if (state.product_list['marketplaceListing']?.NotInPricebook) {
      return <> </>
   }

   if (permissions.includes(state.user_role) || state.productMarketplaceListing)
      return (
         <div className='row'>
            <div className='col-bhr1'>
               {state.product_list['marketplaceListing']['ProductName']}
            </div>
            <div className='col-bhr2'>
               <input
                  className='input-field'
                  type='checkbox'
                  checked={state.productMarketplaceListing}
                  onChange={() => state.setMarketplaceListing((prev) => !prev)}
               ></input>
            </div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'>
               {formatFloatAsCurrencySymbol(
                  state.MarketplaceListingCosts.totalPrice,
                  state.currencyObject,
               )}
            </div>
            {state.differenceQuote == true ? (
               <>
                  <div className='col'></div>
                  <div className='col'></div>
               </>
            ) : (
               <></>
            )}
         </div>
      )

   return null
}
